module.exports = {
  availableThemes: ['default', 'minus15'],
};
